package game

enum class Player { RED, YELLOW }
